
<div *ngIf="isScreenSizeValid()">
  <app-loader *ngIf="(isAppLoading$ | async) === true"></app-loader>
  <router-outlet></router-outlet>
</div>

<div *ngIf="!isScreenSizeValid()">
  <p>Désolé, nous ne prenons pas encore en charge les petits écrans !</p>
</div>